import { LinkCodeModal } from "../shared/LinkCodeModal.js";
import { useOrgGenerateLinkCode, useOrgRedeemLinkCode } from "../../app/hooks/useRoster.js";

/**
 * The ORG side of the "Link a team" code handshake (PO, 2026-08-20): generate a one-time code for an
 * artist, or redeem the code an artist generated. Same shared modal as the band side — only the
 * endpoints and the counterparty vocabulary differ. NOTE the redeemed artist joins the ROSTER RAIL
 * only once someone is assigned; the link itself is live immediately (it sits in the artist's Your
 * Teams card).
 */
export function LinkArtistModal({ orgId, onClose }: { orgId: string | undefined; onClose: () => void }) {
  const generate = useOrgGenerateLinkCode(orgId);
  const redeem = useOrgRedeemLinkCode(orgId);
  return (
    <LinkCodeModal
      title="Link an artist"
      generateHint="Generate a one-time code, then send it to the artist. They redeem it from their Contacts page and the link goes live instantly."
      redeemHint="Enter the code the artist generated for you."
      redeemedNote="Linked — you're on the artist's team. They appear in your roster once a teammate is assigned."
      onGenerate={() => generate.mutateAsync()}
      onRedeem={(code) => redeem.mutateAsync(code)}
      generating={generate.isPending}
      redeeming={redeem.isPending}
      onClose={onClose}
    />
  );
}
